import { useStartStopwatch } from './use-start-stopwatch';
import { useStopStopwatch } from './use-stop-stopwatch';

export const useStopwatch = () => {
  const start = useStartStopwatch();
  const stop = useStopStopwatch();

  return { start, stop };
};
